import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import { message, Modal, Spin } from "antd";
import { FaFileAlt } from "react-icons/fa";
import UserService from "../../../Services/UserService";
import CommonFunctions from "../../Shared/CommonFunctions";

function MappedClinics() {
  const loggedUserJson = localStorage.getItem("login_result");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

  const [loading, setLoading] = useState(true);
  const [clinicList, setClinicList] = useState([]);
  const [clinicData, setClinicData] = useState(null);
  const [editEnable, setEditEnable] = useState(false);


  const getClincListDetails = async () => {
    setLoading(true);
    let payload = {
      account_Id: loggedUser.user.account_Id,
      userId: loggedUser.user.userId,
      status: 1,
    };

    try {
      let result = await UserService.UserClinicColorCode(payload);
      setClinicData(result?.data[0]);
      setClinicList(result?.data[0]?.clinicDetailsList);
      setLoading(false);
    } catch (error) {
      console.error("error", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getClincListDetails();
  }, []);

  const handleColorChange = (e, selectedClinic) => {
    const updatedList = clinicList.map((clinic) =>
      clinic.clinic_Id === selectedClinic.clinic_Id
        ? { ...clinic, colorCode: e.target.value }
        : clinic
    );

    setClinicList(updatedList);
  };

  const handleSave = async () => {
    let payload = {
      accountName: clinicData.accountName,
      account_Id: clinicData.account_Id,
      clinicDetailsList: clinicList,
      createdBy: clinicData.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      modifiedBy: clinicData.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      status: 1,
      userId: clinicData.userId,
      colorCode: "#4922a5",
    };

 
    try {
      await UserService.userMultiClinicMapping(payload);
      message.success("Changes updated successfully.");
      getClincListDetails();
      setEditEnable(false);
    } catch (error) {
      console.error("Error updating changes:", error);
    }
  };

  return (
    <Layouts>
      {loading ? (
        <div className="flex justify-center items-center mt-40">
          <Spin />
        </div>
      ) : (
        <>
          <div className="flex justify-between items-center">
            <div className="w-[40%] cursor-pointer font-bold">
              Mapped Clinics
            </div>
            {editEnable ? (
              <button
                onClick={handleSave}
                className="px-2 py-1 w-20 rounded text-white "
              >
                Save
              </button>
            ) : (
              <button
                onClick={() => setEditEnable(true)}
                className="px-2 py-1 w-20 rounded text-white "
              >
                Edit
              </button>
            )}
          </div>
          <div className="mt-10 mb-10  rounded-lg h-full">
            <div className="p-1">
              <div className="w-full overflow-x-auton overflow-y-hidden">
                {clinicList && clinicList.length > 0 ? (
                  <table className="w-full border border-gray-200 shadow-md rounded-md customTable mt-4">
                    <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
                      <tr className="font-sans font-normal">
                        <th className="p-3 whitespace-nowrap">Clinic Id</th>
                        <th className="p-3 whitespace-nowrap">Clinic Name</th>
                        <th className="p-3 whitespace-nowrap">
                          Default Clinic
                        </th>
                        <th className="p-3 whitespace-nowrap">Color Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clinicList.map((clinic, index) => (
                        <tr
                          key={index}
                          className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                        >
                          <td className="p-3 whitespace-nowrap ">
                            {clinic.clinic_Id}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {clinic.clinicName}
                          </td>
                          <td className="p-3 whitespace-nowrap ">
                            {clinic.defaultClinic}
                          </td>
                          <td
                            className="p-3 whitespace-nowrap "
                            // onClick={() => showEdit(clinic)}
                          >
                            <input
                              type="color"
                              id="favcolor"
                              name="favcolor"
                              value={clinic?.colorCode}
                              disabled={!editEnable}
                              // style={{ pointerEvents: "none" }}
                              onChange={(e) => handleColorChange(e, clinic)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="w-full max-w-md mx-auto mt-10 bg-white  rounded-2xl p-6 flex flex-col items-center text-center">
                    <FaFileAlt className="text-gray-400 w-16 h-16 mb-4" />
                    <h2 className="text-xl font-semibold text-gray-700">
                      No Data
                    </h2>
                    <p className="text-gray-500 mt-2"></p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </Layouts>
  );
}

export default MappedClinics;
